import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';
import { FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Answer, Status } from '../shared/enum/shared.enum';

@Injectable({
  providedIn: 'root'
})
export class WorkpermitService {
  signatureImage = new BehaviorSubject<any>({});
  observer = this.signatureImage.asObservable();
  constructor(
    private httpClient: HttpClient,
    public fb: FormBuilder
  ) { }

  getUserFormGroup() {
    return this.fb.group({
      aadharNo: [''],
      active: [Status.active],
      bloodGroup: [''],
      contactNo: [''],
      createdAt: [''],
      deleted: [false],
      designation: [],
      email: [],
      emergencyContactNumber: [],
      firstName: [''],
      forgotPasswordDate: [''],
      forgotPasswordToken: [''],
      id: [null],
      isFirstTime: [false],
      lastName: [''],
      profilePhoto: [''],
      secondaryEmail: [''],
      updatedAt: [''],
      userGroup: [''],
      userType: [''],
      username: ['']
    })
  }

  getWorkPermitContractorSignsRequestsFormGroup(srNo) {
    return this.fb.group({
      srNo: [srNo],
      fileName: [''],
      id: [null],
      name: [''],
      signature: [''],
      user: [null],
    })
  }

  getSignatureFormGroup() {
    return this.fb.group({
      fileName: ['', [Validators.required]],
      id: [null],
      name: [''],
      signUserType: [''],
      signature: ['', [Validators.required]],
      user: [null],
    })
  }

  getSignatureFormGroupNotRequired() {
    return this.fb.group({
      fileName: [''],
      id: [null],
      name: [''],
      signUserType: [''],
      signature: [''],
      user: [null],
    })
  }

  getJobSafetyApprovalSignatureFormGroup() {
    return this.fb.group({
      fileName: [''],
      id: [null],
      name: [''],
      remark: [''],
      signUserType: [''],
      signature: [''],
      user: [null],
      wpNo: [null]
    })
  }

  getInchargeSignatureFormGroup() {
    return this.fb.group({
      fileName: [''],
      id: [null],
      name: [''],
      signUserType: [''],
      inChargeSignature: [''],
      userId: [null]
    })
  }

  getSafetyOfficerSignatureFormGroup() {
    return this.fb.group({
      fileName: [''],
      id: [null],
      name: [''],
      signUserType: [''],
      safetyOfficerSignature: [''],
      userId: [null]
    })
  }

  getAreaFormGroup() {
    return this.fb.group({
        active: [""],
        areaName: [''],
        createdAt: [''],
        createdBy: [],
        id: [null],
        lastModifiedBy: [''],
        updatedAt: ['']
    })
  }

  getWorkDetailFormGroup() {
    return this.fb.group({
      actions: [''],
      area: this.getAreaFormGroup(),
      areaInCharge: [null],
      dateOfIssue: [''],
      descriptionOfWork: [''],
      emailOfContractor: [''],
      fromDate: [''],
      fromTime: [''],
      id: [null, Validators.required],
      isDraft: [false],
      issuedBy: [null],
      mobileNoOfContractor: [''],
      mobileNoOfSupervisor: [''],
      nameOfContractor: [''],
      nameOfSupervisor: [''],
      responsibleSAVW_Department: ['', [Validators.required]],
      responsibleSAVW_ContactNo: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      responsibleSAVW_Person: this.getUserFormGroup(),
      safetyManagerId: [null],
      status: [''],
      status_reason: [''],
      toDate: [''],
      toTime: [''],
      typeOfWork: this.fb.array([], [this.requireCheckboxesToBeCheckedValidator()]),
      wpNo: [null, [Validators.required]]
    })
  }

  requireCheckboxesToBeCheckedValidator(minRequired = 1): ValidatorFn {
    return function validate(formGroup: FormGroup) {
      let checked = 0;
      Object.keys(formGroup.controls).forEach(key => {
        const control = formGroup.controls[key];
        if (control.value === true) {
          checked++;
        }
      });
      if (checked < minRequired) {
        return {
          requireOneCheckboxToBeChecked: true,
        };
      }
      return null;
    };
  }

  getWorkPermitClosureSignatureFormGroup() {
    return this.fb.group({
      fileName: [''],
      id: [null],
      name: [''],
      signUserType: [''],
      signature: [''],
      user: [null],
      wpNo: [null]
    })
  }

  getJobSpecificHazardRiskForm() {
    return this.fb.group({
      id: [null],
      hazard: [''],
      risk: ['']
    })
  }


  getJobSpecificRiskAssessmentPayloadFormGroup() {
    return this.fb.group({
      activitySpecificControlMeasure: ['', [Validators.required]],
      id: [null],
      inChargeSignature: ['', [Validators.required]],
      inChargefileName: [''],
      safetyOfficerSignature: ['', [Validators.required]],
      safetyOfficerfileName: [''],
      jobSpecificHazardRisk: this.fb.array([]),
      jobSpecificRiskApproval: [],
      nameOfAuthorizedEmployee: ['', [Validators.required]],
      nameOfSafetyOfficerAndSupervisor: ['', [Validators.required]],
      uploadFile: [''],
      workPermit: [''],
      uploadImage: ['', [Validators.required]],
      uploadedFileName: [''],
      uploadedImageFileName: [''],
      user: [null],
    })
  }

  getJobSafetyAnalysisRequestFormGroup() {
    return this.fb.group({
      controlMeasures: [''],
      description: [''],
      hazard: [''],
      id: [null],
      risk: [''],
      userId: [0],
      wpNo: [null]
    })
  }

  getJobSpecificHazardRiskFomeGroup() {
    return this.fb.group({
      createdAt: [''],
      createdBy: [''],
      hazard: [''],
      id: [null],
      lastModifiedBy: [''],
      risk: [''],
      updatedAt: [''],
    })
  }

  getjobSpecificRiskAssessmentFormGroup() {
    return this.fb.group({
      activitySpecificControlMeasure: [''],
      id: [null],
      jobSpecificHazardRisk: this.fb.array([this.getJobSpecificHazardRiskFomeGroup()]),
      nameOfAuthorizedEmployee: [''],
      nameOfSafetyOfficerAndSupervisor: [''],
      uploadFile: [''],
      uploadImage: [''],
      uploadedFileName: [''],
      uploadedImageFileName: [''],
      user: [null]
    })
  }

  getCheckListQuestionsAnswersFormGroup() {
    return this.fb.group({
      active: [true],
      answer: [],
      name: [''],
      checkList: [null],
      checkListQuestion: [''],
      id: [null],
      remark: []
    })
  }

  emitSignature(data: any) {
    this.signatureImage.next(data);
  }

  getAllDataById(relativeUrl: string, data1: any): Observable<any> {
    return this.httpClient.get(environment.baseUrl + relativeUrl + "/" + data1);
  }

  getWPDetails(relativeUrl: string, data1: any): Observable<any> {
    return this.httpClient.get(environment.baseUrl + relativeUrl + "/" + data1);
  }
  getWPDetailsByID(relativeUrl: string): Observable<any> {
    return this.httpClient.get(environment.baseUrl + relativeUrl);
  }
  getAllCheckList(relativeUrl: string): Observable<any> {
    return this.httpClient.get(environment.baseUrl + relativeUrl);
  }

  getCheckListQuestionById(relativeUrl: string, id: any): Observable<any> {
    return this.httpClient.get(environment.baseUrl + relativeUrl + "/" + id);
  }

  workPermitApproval(relativeUrl: string, data: any) {
    return this.httpClient.post(environment.baseUrl + relativeUrl, data);
  }

  addOrUpdateWorkPermitContractor(relativeUrl: string, data: any) {
    return this.httpClient.post(environment.baseUrl + relativeUrl, data);
  }

  getAllDailyActivity(relativeUrl: string): Observable<any> {
    return this.httpClient.get(environment.baseUrl + relativeUrl);
  }

  private GetDates(startDate, daysToAdd) {
    var aryDates = [];

    for (let i = 0; i <= daysToAdd; i++) {
      let currentDate = new Date();
      
      aryDates.push(currentDate);
    }

    return aryDates;
  }

  // private MonthAsString(monthIndex) {
  //   var d = new Date();
  //   var month = new Array();
  //   month[0] = "January";
  //   month[1] = "February";
  //   month[2] = "March";
  //   month[3] = "April";
  //   month[4] = "May";
  //   month[5] = "June";
  //   month[6] = "July";
  //   month[7] = "August";
  //   month[8] = "September";
  //   month[9] = "October";
  //   month[10] = "November";
  //   month[11] = "December";

  //   return month[monthIndex];
  // }

  // private DayAsString(dayIndex) {
  //   var weekdays = new Array(7);
  //   weekdays[0] = "Sunday";
  //   weekdays[1] = "Monday";
  //   weekdays[2] = "Tuesday";
  //   weekdays[3] = "Wednesday";
  //   weekdays[4] = "Thursday";
  //   weekdays[5] = "Friday";
  //   weekdays[6] = "Saturday";

  //   return weekdays[dayIndex];
  // }

  getDatesFromDate(startDate) {
    const currentDate = new Date(startDate);
    const dateArray = new Array(7).fill(currentDate).map((_currentDate: Date, i) => {
      return _currentDate.setDate(new Date(startDate).getDate() + i)
    });
    console.log('dateArray', dateArray);
    return dateArray;
  }
}
